import { regionDataQuery_Client } from '@/app/data/regionData.client';
import isSSR from '@/utils/isSSR';
import logger from '@/app/logger';
import { useQuery, useQueryClient } from '@tanstack/vue-query';
import { onServerPrefetch, ref, toValue, type MaybeRefOrGetter, type Ref } from 'vue';

const queryFn = async (region: string) => {
  if (isSSR) {
    const { regionDataQuery_Server } = await import('@/server/data/regionData.server');
    return regionDataQuery_Server(region);
  } else {
    return regionDataQuery_Client(region);
  }
};

export const getRegionQueryKey = (regionId: string) => ['region', regionId];

export default function useRegionData(regionId: MaybeRefOrGetter<string>, enabledRef: Ref<boolean> = ref(true)) {
  logger.info('useRegionData with region: ' + toValue(regionId));
  const query = useQuery({
    queryKey: [getRegionQueryKey, regionId],
    queryFn: () => queryFn(toValue(regionId)),
    enabled: enabledRef,
  });

  onServerPrefetch(async () => {
    if (toValue(regionId)) {
      const queryClient = useQueryClient();
      await queryClient.prefetchQuery({ queryKey: [getRegionQueryKey, regionId] });
    }
  });

  return query;
}
